import { REQUIRED_MESSAGE, requiredString } from '@wyz/utils';
import { z } from 'zod';
import { associatedCriteriaSchema, externalIdSchema } from '~/common/schemas';

export const BRAND_EAN_SPECIFICATIONS = {
  NO_SPECIFICATION: 'NO_SPECIFICATION',
  WYZ_REFERENTIAL: 'WYZ_REFERENTIAL',
  CONTRACT_NUMBER: 'CONTRACT_NUMBER',
} as const;

export const brandSchema = z.object({
  publicKey: z.string(),
  name: z.string(),
  segment: z.object({ publicKey: z.string() }),
  brandEanSpecification: z.enum(BRAND_EAN_SPECIFICATIONS).nullish(),
  desadv: z.boolean().nullish(),
  recommended: z.boolean(),
});

export const brandTemplateSchema = z.object({
  id: z.string(),
  name: requiredString,
  criteria: z.array(associatedCriteriaSchema),
  brandEanSpecification: z.enum(BRAND_EAN_SPECIFICATIONS),
  desadv: z.boolean().nullish(),
  brands: z
    .array(
      z.object({
        externalId: externalIdSchema,
        brandEanSpecification: z.enum(BRAND_EAN_SPECIFICATIONS).nullish(),
        desadv: z.boolean().nullish(),
        recommended: z.boolean(),
      }),
    )
    .min(1, REQUIRED_MESSAGE),
});

export const brandTemplateFormSchema = brandTemplateSchema
  .omit({
    id: true,
    criteria: true,
    brands: true,
  })
  .extend({
    criteria: z
      .array(
        z.object({
          criterion: z.object({ id: z.string() }),
          values: z.array(requiredString).min(1, {
            error: REQUIRED_MESSAGE,
          }),
        }),
      )
      .min(1, {
        error: REQUIRED_MESSAGE,
      }),
    brands: z.array(brandSchema).min(1, REQUIRED_MESSAGE),
  });

export const brandTemplatePayloadSchema = brandTemplateSchema.omit({
  id: true,
});
